<template>
    <div>
        <el-card class="box-card">
            <el-form inline @submit.native.prevent size="mini">

                <el-form-item label="线程数">
                    <el-input v-model.number="formModel.maxThreads" auto-complete="off" maxlength='30'
                              placeholder="检测线程数" style="width: 80px"/>
                </el-form-item>
                <el-form-item label="超时时间">
                    <el-input v-model.number="formModel.timeout" auto-complete="off" maxlength='30'
                              placeholder="超时时间" style="width: 150px">
                        <span slot="append">秒</span>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="startDetection"
                        :disabled="isDetecting"
                        icon="el-icon-search">
                        开始检测
                    </el-button>

                    <el-button
                        type="danger"
                        @click="stopDetection"
                        :disabled="!isDetecting"
                        icon="el-icon-circle-close">
                        停止检测
                    </el-button>

                    <el-button
                        type="info"
                        @click="clearResults"
                        icon="el-icon-delete">
                        清除结果
                    </el-button>

                    <el-button
                        type="text"
                        @click="showSample">
                        查看示例格式
                    </el-button>
                </el-form-item>


                <div class="progress-info" style="display: inline-flex;align-items: center; margin-left: 10px;"
                     v-if="progress.total > 0">
                    <el-progress
                        style="width: 150px;margin-right: 10px"
                        :show-text="false"
                        :percentage="progressPercentage"
                        :status="progressStatus"
                        :stroke-width="8">
                    </el-progress>
                    <span>检测进度: {{ progress.completed }}/{{ progress.total }} ({{ progressPercentage }}%)</span>
                    <span style="width: 12px;height:12px" v-loading="isDetecting"></span>
                </div>
            </el-form>
        </el-card>
        <div style="height: 10px"></div>

        <el-card>

            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input
                        class="proxy-input"
                        type="textarea"
                        :rows="34" resize="none"
                        placeholder="请输入代理列表，每行一个代理，格式如: http://user:pass@host:port 或 socks5://host:port"
                        v-model="proxyListText">
                    </el-input>


                </el-col>
                <el-col :span="18">
                    <vxe-table :data="proxyResults" border stripe align="center"

                               :height="620"
                    >
                        <vxe-table-column type="seq" width="50"></vxe-table-column>
                        <vxe-table-column field="proxy" label="代理地址" width="200"></vxe-table-column>
                        <vxe-table-column field="status" label="状态" width="80">
                            <template #default="{row}">
                                <el-tag :type="row.status === 'active' ? 'success' : 'danger'" size="small">
                                    {{ row.status === 'active' ? '可用' : '不可用' }}
                                </el-tag>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="latency" label="延迟(ms)" width="80">
                            <template #default="{row}">
                                <span>
                                    {{ row.status === 'active' ? row.latency : '-' }}
                                </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="ip" label="IP" width="120">
                            <template #default="{row}">
                                {{ row.ip || '-' }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="location" label="归属地" width="200">
                            <template #default="{row}">
                                {{ row.location ? row.location.join('') : '-' }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="checkTime" label="检测时间" width="140"></vxe-table-column>
                        <vxe-table-column field="details" label="错误信息" width="250"></vxe-table-column>
                        <!--                        <vxe-table-column
                                                    label="操作"
                                                    width="80">
                                                    <template #default="{row}">
                                                        <el-button
                                                            size="mini"
                                                            @click="retryDetection(row.proxy)">
                                                            重试
                                                        </el-button>
                                                    </template>
                                                </vxe-table-column>-->
                    </vxe-table>
                </el-col>
            </el-row>


        </el-card>
    </div>


</template>

<script>

const axios = require('axios');


export default {
    name: "ProxyDetect",
    components: {},
    data() {
        return {
            formModel: {
                maxThreads: 10,
                timeout: 5,
            },

            proxyListText: '',
            isDetecting: false,
            eventSource: null,
            clientId: null,
            progress: {
                completed: 0,
                total: 0
            },
            proxyResults: []
        }
    },
    computed: {
        progressPercentage() {
            if (this.progress.total === 0) return 0;
            return Math.round((this.progress.completed / this.progress.total) * 100);
        },
        progressStatus() {
            return this.progressPercentage === 100 ? 'success' : '';
        },
        hasLatency() {
            return this.proxyResults.some(item => item.latency !== undefined);
        },
        hasError() {
            return this.proxyResults.some(item => item.error);
        }
    },
    methods: {
        parseProxyList() {
            return this.proxyListText
                .split('\n')
                .map(line => line.trim())
                .filter(line => line.length > 0);
        },
        async startDetection() {
            if (this.isDetecting) return;

            try {
                const proxies = this.parseProxyList();
                if (proxies.length === 0) {
                    this.$message.warning('请输入有效的代理地址');
                    return;
                }

                this.isDetecting = true;
                this.progress = {completed: 0, total: proxies.length};

                // 清除已有结果
                this.proxyResults = [];

                // 建立SSE连接
                if (!this.eventSource) {
                    await this.setupSSEConnection();
                }

                // 发送检测请求
                const response = await axios.post('/api/proxy/check', {
                    proxies,
                    clientId: this.clientId,

                    maxThreads: this.formModel.maxThreads,
                    timeout: this.formModel.timeout * 1000,
                }, {
                    timeout: this.formModel.timeout * 1000,
                })
                if (!response.data.success) {
                    this.$message.error('检测出错: ' + response.data.message);
                    this.isDetecting = false;
                }


            } catch (error) {
                this.$message.error('检测出错: ' + error.message);
                this.isDetecting = false;
            }
        },


        async stopDetection() {
            if (!this.isDetecting || !this.clientId) return;

            try {
                await axios.post('/api/proxy/cancel', {
                    clientId: this.clientId
                });
                this.isDetecting = false;
                this.$message.success('已停止检测');
            } catch (error) {
                this.$message.error('停止检测出错: ' + error.message);
            }
        },
        clearResults() {
            this.proxyResults = [];
            this.progress = {completed: 0, total: 0};
        },

        retryDetection(proxy) {
            if (this.isDetecting) return;

            this.$confirm(`确定要重新检测代理 ${proxy} 吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.proxyListText = proxy;
                this.startDetection();
            }).catch(() => {
            });
        },
        showSample() {
            this.$alert(`
                <div>支持的代理格式示例：</div>
                <ol>
                    <li>HTTP代理: http://username:password@host:port</li>
                    <li>HTTP代理: HTTPS代理: https://host:port</li>
                    <li>HTTP代理: SOCKS5代理: socks5://user:pass@host:port</li>
                    <li>简化格式: host:port (默认为HTTP)</li>
                </ol>
                <div>示例代理列表：</div>
                <ol>
                    <li>http://user1:pass123@proxy1.example.com:8080</li>
                    <li>socks5://proxy2.com:1080</li>
                    <li>https://192.168.1.100:3128</li>
                    <li>example.proxy:9999</li>
                </ol>
                `,
                '代理格式说明', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定'
                }
            ).catch(() => {
            });
        },
        setupSSEConnection() {
            return new Promise((resolve, reject) => {
                this.eventSource = new EventSource('/api/proxy/events');

                this.eventSource.addEventListener('handshake', (event) => {
                    const data = JSON.parse(event.data);
                    this.clientId = data.clientId;
                    resolve();
                });

                this.eventSource.addEventListener('progress', (event) => {
                    this.progress = JSON.parse(event.data);
                });

                this.eventSource.addEventListener('result', (event) => {
                    const result = JSON.parse(event.data);
                    this.proxyResults.push(result);
                });

                this.eventSource.addEventListener('complete', (event) => {
                    const data = JSON.parse(event.data);
                    this.$message.success(data.message);
                    this.isDetecting = false;
                });

                this.eventSource.addEventListener('error', (event) => {
                    try {
                        const data = JSON.parse(event.data);
                        this.$message.error(data.message);
                    }catch (e) {
                        // this.$message.error(e.message);
                    } finally {
                        this.isDetecting = false;
                    }
                });

                this.eventSource.onerror = () => {
                    // this.$message.error('SSE连接中断');
                    this.isDetecting = false;
                    reject(new Error('SSE连接失败'));
                };
            });
        }
    },
    beforeDestroy() {
        if (this.eventSource) {
            this.eventSource.close();
        }
    }
}
</script>

<style scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0;

}

::v-deep .el-form-item {
    margin-bottom: 0;
}
</style>
